// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
}

/* Background and layout */
body {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f3f4f6;
}

/* Chat container */
.chat-container {
    display: flex;
    flex-direction: column;
    width: 80%;
    max-width: 600px;
    height: 90vh;
    background-color: #ffffff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
}

/* Top navigation bar */
.top-nav {
    padding: 15px;
    background-color: #2197F3;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
}

.top-nav .logo,
.top-nav .logo-mobile {
    font-weight: bold;
}

.top-nav .nav-links a {
    color: #ffffff;
    text-decoration: none;
    margin-left: 15px;
    font-size: 14px;
}

.top-nav .nav-links a:hover {
    text-decoration: underline;
}

/* Input area */
.chat-input-area {
    display: flex;
    border-top: 1px solid #e0e0e0;
    padding: 10px;
    background-color: #ffffff;
}

/* Text input */
.chat-input {
    flex: 1;
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 20px;
    font-size: 16px;
    outline: none;
}

/* Send button */
.send-button {
    padding: 10px 15px;
    margin-left: 10px;
    background-color: #2f3e46;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 45px;
    width: 45px;
}

.send-button:hover {
    background-color: #455a64;
}

.logo-mobile {
    display: none;
}

@media (max-width: 1024px) {
    .logo {
        display: none;
    }

    .logo-mobile {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/css/app.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,OAAO;IACP,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/* Reset */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: Arial, sans-serif;\n}\n\n/* Background and layout */\nbody {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f3f4f6;\n}\n\n/* Chat container */\n.chat-container {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    max-width: 600px;\n    height: 90vh;\n    background-color: #ffffff;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n/* Top navigation bar */\n.top-nav {\n    padding: 15px;\n    background-color: #2197F3;\n    color: #ffffff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 18px;\n}\n\n.top-nav .logo,\n.top-nav .logo-mobile {\n    font-weight: bold;\n}\n\n.top-nav .nav-links a {\n    color: #ffffff;\n    text-decoration: none;\n    margin-left: 15px;\n    font-size: 14px;\n}\n\n.top-nav .nav-links a:hover {\n    text-decoration: underline;\n}\n\n/* Input area */\n.chat-input-area {\n    display: flex;\n    border-top: 1px solid #e0e0e0;\n    padding: 10px;\n    background-color: #ffffff;\n}\n\n/* Text input */\n.chat-input {\n    flex: 1;\n    padding: 10px;\n    border: 1px solid #e0e0e0;\n    border-radius: 20px;\n    font-size: 16px;\n    outline: none;\n}\n\n/* Send button */\n.send-button {\n    padding: 10px 15px;\n    margin-left: 10px;\n    background-color: #2f3e46;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 45px;\n    width: 45px;\n}\n\n.send-button:hover {\n    background-color: #455a64;\n}\n\n.logo-mobile {\n    display: none;\n}\n\n@media (max-width: 1024px) {\n    .logo {\n        display: none;\n    }\n\n    .logo-mobile {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
